'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

var mapDispatchToProps = {
    removeCoupon: _actions2.default.removeCoupon
};

var Voucher = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
    (0, _inherits3.default)(Voucher, _React$PureComponent);

    function Voucher() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Voucher);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Voucher.__proto__ || (0, _getPrototypeOf2.default)(Voucher)).call.apply(_ref, [this].concat(args))), _this), _this.handleDelete = function () {
            _this.props.removeCoupon(true);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Voucher, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                code = _props.code,
                nominalValue = _props.nominalValue;

            var display = !!code;
            if (!display) return null;

            return _react2.default.createElement(
                'div',
                { className: 'cart__item cart__item--voucher' },
                _react2.default.createElement(
                    'div',
                    { className: 'cart-i__first' },
                    _react2.default.createElement(
                        'span',
                        { className: 'cart__voucher' },
                        _react2.default.createElement(
                            'span',
                            { className: 'bl' },
                            name
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'cart__voucher-code' },
                            code
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart-i__last' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-i__summary green' },
                        (0, _linksoftAlbatros.formatPrice)(-nominalValue, _linksoftAlbatros.PriceType.CartTotalPrice)
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn__square cart-i__remove coupon-remove', onClick: this.handleDelete },
                        _react2.default.createElement('i', { className: 'icon--cross' })
                    )
                )
            );
        }
    }]);
    return Voucher;
}(_react2.default.PureComponent)) || _class);
exports.default = Voucher;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/Voucher.js
// module id = 1132
// module chunks = 0